var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 14.5,
    cy: 14,
    r: 14,
    fill: "#6A758B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7514 19.3531L18.6096 11.7773C18.9279 11.3688 19.0411 10.8965 18.935 10.4156C18.843 9.97837 18.5742 9.56267 18.1709 9.24732L17.1875 8.46609C16.3314 7.7852 15.2701 7.85688 14.6616 8.6381L14.0037 9.49172C13.9188 9.59851 13.94 9.75619 14.0461 9.8422C14.0461 9.8422 15.7088 11.1753 15.7441 11.204C15.8573 11.3115 15.9422 11.4548 15.9635 11.6268C15.9988 11.9637 15.7654 12.2791 15.4187 12.3221C15.256 12.3436 15.1003 12.2934 14.9871 12.2002L13.2396 10.8098C13.1546 10.746 13.0273 10.7596 12.9565 10.8456L8.80346 16.221C8.5346 16.5579 8.44263 16.9951 8.5346 17.4179L9.06524 19.7186C9.09354 19.8405 9.19966 19.9265 9.32701 19.9265L11.6618 19.8978C12.0863 19.8906 12.4825 19.6971 12.7514 19.3531ZM16.0211 18.6355H19.8282C20.1996 18.6355 20.5018 18.9415 20.5018 19.3178C20.5018 19.6948 20.1996 20.0001 19.8282 20.0001H16.0211C15.6496 20.0001 15.3475 19.6948 15.3475 19.3178C15.3475 18.9415 15.6496 18.6355 16.0211 18.6355Z",
    fill: "#6A758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f7fdb3ca7fb8ce1bf6b69a4143167741.svg";
export { ForwardRef as ReactComponent };